// src/errors/Unauthorized.tsx

import ErrorPage from "./ErrorPage";

export default function Unauthorized() {
    return (
        <ErrorPage
            variant="forbidden"
            statusLabel="Permission status"
            statusCode={403}
            title="Access Denied"
            message="You do not have permission to view this page or perform this action. Please contact your admin if you believe this is an error."
            actionLabel="Go to Dashboard"
            redirectTo="/"
            secondaryActionLabel="Go Back"
            secondaryActionType="back"
            helperText="Your current role may not include the permission required for this area."
        />
    );
}